import { Button, Grid, Typography, TextField, Box, Hidden
    , FormControl, InputLabel, Select } from "@mui/material";
import { Search as IconSearch } from "@mui/icons-material";
import * as terapiaService from "../../services/terapiaService";
import * as periodoService from "../../services/periodoService";
import * as personaService from "../../services/personaService";
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { setValue, setNombreTerapeuta, setResults, setListPeriodos, setListTiposTerapias, setListEstados } from '../../redux/sessionTherapistSearchSlice';
import DialogYesNo from '../../components/DialogYesNo';
import DataGridBase from "../../components/common/DataGridBase"

const IndexTherapist = () => {
    const params = useParams();
    const filters = useSelector((state) => state.sessionTherapistSearch.filters);
    const nombreTerapeuta = useSelector((state) => state.sessionTherapistSearch.nombreTerapeuta);
    const listPeriodos = useSelector((state) => state.sessionTherapistSearch.listPeriodos);
    // const listTiposTerapias = useSelector((state) => state.sessionTherapistSearch.listTiposTerapias);
    // const listEstados = useSelector((state) => state.sessionTherapistSearch.listEstados);
    
    // const [openDialogAnnulActive, setOpenDialogAnnulActive] = useState(false)
    // const openCloseDialogAnnulActive = () => { setOpenDialogAnnulActive(!openDialogAnnulActive); }
    const [selectId, setSelectId] = useState(null);
    const [selectState, setSelectState] = useState(null);

    const [cargando, setCargando] = useState(true);
    const [results, setResults] = useState([]);
    const dispatch = useDispatch();

    const fetchResults = async () => {
        setCargando(true);

        await terapiaService.getsTerapiaPeriodoResumenView({
                idPeriodo: filters.idPeriodo,
                idTipoTerapia: 0,
                participante: filters.participante,
                idTerapeuta: params.id,
                terapeuta: "",
                idEstado: 2,
            })
            .then((data) => {
                setResults(data);
                setCargando(false);
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchPeriodos = async () => {
        await periodoService.getsPeriodoView({
                idTipoTerapia: 0,
                idEstadoApertura: 87,
                mesesHaciaAtras: 0,
                idEstado: 2,
            })
            .then((data) => {
                dispatch(setListPeriodos(data));
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchNombreTerapeuta = async () => {
        await personaService.getPersonaById(params.id)
            .then((data) => {
                console.log(data)

                dispatch(setNombreTerapeuta(data.nombres));
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    // const fetchTiposTerapias = async () => {
    //     await api
    //         .get('/Catalogo/GetCatalogosByIdPadreInLista?'
    //         + 'idPadre=49'
    //         )
    //         .then((response) => {
    //             dispatch(setListTiposTerapias(response.data.data));
    //         })
    //         .catch((err) => {
    //             console.log("Err: ", err)
    //         });
    // }
    // const fetchEstados = async () => {
    //     await api
    //         .get('/Catalogo/GetCatalogosByIdPadreInLista?'
    //         + 'idPadre=1'
    //         )
    //         .then((response) => {
    //             dispatch(setListEstados(response.data.data));
    //             dispatch(setValue({name: "idEstado", value: 2}))
    //         })
    //         .catch((err) => {
    //             console.log("Err: ", err)
    //         });
    // }
    // const annulTerapiaPeriodo = async () => {
    //     await api
    //         .post("/Terapia/AnnulTerapiaPeriodo?idTerapiaPeriodo=" + selectId)
    //         .catch((err) => {
    //             console.log("Err: ", err);
    //         });
    //         fetchResults();
    // }
    // const activeTerapiaPeriodo = async () => {
    //     await api
    //         .post("/Terapia/ActiveTerapiaPeriodo?idTerapiaPeriodo=" + selectId)
    //         .catch((err) => {
    //             console.log("Err: ", err);
    //         });
    //         fetchResults();
    // }

    useEffect(() => {
        fetchResults();
        fetchPeriodos();
        fetchNombreTerapeuta();
        // fetchTiposTerapias();
        // fetchEstados();
    }, []);

    const columns = [
        // { field: 'id', headerName: 'ID', width: 50, sortable: false, headerAlign: 'center', align: 'center' },
        // { field: 'codigoServicio', headerName: 'Servicio', width: 50, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'participante', headerName: 'Participante', width: 200, sortable: true, headerAlign: 'center'
            , renderCell: (cellValues) => {
                return <Link to={'/session/edit/0/' + cellValues.row.id} style={{ color: 'inherit' }}>{cellValues.row.participante}</Link>;
            }
        },
        { field: 'codigoPeriodo', headerName: 'Periodo', width: 100, sortable: false, headerAlign: 'center', align: 'center' },
        // { field: 'terapeuta', headerName: 'Terapeuta', width: 200, sortable: true, headerAlign: 'center' },
        { field: 'estadoApertura', headerName: 'Apertura', width: 80, sortable: true, headerAlign: 'center', align: 'center' },
        // { field: 'codigoTarifa', headerName: 'Tarifa', width: 80, sortable: false, headerAlign: 'center', align: 'center' },
        // { field: 'salon', headerName: 'Salon', width: 100, sortable: true, headerAlign: 'center' },
        // { field: 'fechaInicio', headerName: 'Inicio', width: 120, type: 'date'
        //     , valueFormatter: (value) => moment(value).format('D/MM/YYYY')
        //     , sortable: true, headerAlign: 'center', align: 'center' },
        // { field: 'estado', headerName: 'Estado', width: 80, sortable: true, headerAlign: 'center', align: 'center' },
        // { field: 'anular', headerName: '', width: 80, sortable: true, headerAlign: 'center', align: 'center'
        //     , renderCell: (cellValues) => {
        //         return <IconButton aria-label="anular" size='small' style={{height: 10}} align={"center"} onClick={() => {
        //             setSelectId(cellValues.row.id);
        //             setSelectState(cellValues.row.estado);
        //             setOpenDialogAnnulActive(true);
        //         }}>
        //             { cellValues.row.estado == "A" ? <IconIndeterminateCheckBox /> : <IconCheckBox /> }
        //         </IconButton>;
        //     }
        // },
    ];

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        {nombreTerapeuta}
                    </Typography>
                </Grid>
                <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container item xs={12} sm={12} spacing={1} padding={0}>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-periodo">Periodo</InputLabel>
                                    <Select
                                        native
                                        label="Periodo"
                                        value={filters.idPeriodo}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idPeriodo", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idPeriodo',
                                            id: 'input-periodo',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listPeriodos.map((row) => (
                                            <option key={row.id} value={row.id}>{row.codigo}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            {/* <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-tipoterapia">Tipo Terapia</InputLabel>
                                    <Select
                                        native
                                        label="Tipo Terapia"
                                        value={filters.idTipoTerapia}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idTipoTerapia", value: event.target.value}))
                                        }}
                                        inputProps={{
                                            name: 'idTipoTerapia',
                                            id: 'input-tipoterapia',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listTiposTerapias.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid> */}
                            <Grid item xs={8} sm={2}>
                                <TextField
                                    // required
                                    name="participante"
                                    label="Participante"
                                    value={filters.participante}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "participante", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            {/* <Grid item xs={8} sm={4}>
                                <TextField
                                    // required
                                    name="terapeuta"
                                    label="Terapeuta"
                                    value={filters.terapeuta}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "terapeuta", value: event.target.value}))
                                    }}
                                    size="small"
                                />
                            </Grid> */}
                            {/* <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-estado">Estado</InputLabel>
                                    <Select
                                        native
                                        label="Estado"
                                        value={filters.idEstado}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idEstado", value: event.target.value}))
                                        }}
                                        inputProps={{
                                            name: 'idEstado',
                                            id: 'input-estado',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listEstados.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid> */}
                            <Grid item xs={4} sm={1} display={"flex"} alignItems={"center"}>
                                <Button variant="outlined" size="medium" fullWidth onClick={() => {
                                    fetchResults()
                                }}>
                                    {<Hidden smDown></Hidden>}
                                    <IconSearch />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase
                                rows={results}
                                columns={columns}
                                loading={cargando}
                                // hideNewButton={false}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}
export default IndexTherapist
